import script from "./ConditionalOrderDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConditionalOrderDetails.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__